/**
 * Roles del sistema sincronizados con `core.app_role` ENUM (migration 0001).
 * Editar acá requiere ALTER TYPE en SQL + redeploy.
 */
export const APP_ROLES = [
  'superadmin',
  'admin_dendev',
  'directivo',
  'employee',
  'salesperson',
  'external_legacy',
  'guest',
] as const;

export type AppRole = (typeof APP_ROLES)[number];

export const ROLE_LABELS: Record<AppRole, string> = {
  superadmin: 'Super Admin',
  admin_dendev: 'Admin DenDev',
  directivo: 'Directivo',
  employee: 'Empleado',
  salesperson: 'Vendedor',
  external_legacy: 'Externo (legacy)',
  guest: 'Invitado',
};

/**
 * Descripción corta por rol — se muestra al asignarlo desde /admin/usuarios,
 * para que quien asigna entienda el alcance sin abrir la matriz.
 */
export const ROLE_DESCRIPTIONS: Record<AppRole, string> = {
  superadmin: 'Acceso total. Sin restricciones.',
  admin_dendev: 'Gestiona la organización: equipo, IA, cobranzas y campañas.',
  directivo:
    'Toda la parte comercial: prospectos, campañas y leads de todos, y las tareas del equipo. Sin administración, IA ni cobranzas ajenas.',
  employee: 'Trabaja su cartera y ve la agenda de sus áreas.',
  salesperson:
    'Solo su cartera: su canal de chat, su agenda por asignación y sus cobranzas. Sin canales generales ni newsletters.',
  external_legacy: 'Cuenta heredada con acceso mínimo de lectura.',
  guest: 'Solo lo que le compartieron explícitamente.',
};
